
import classNames from "../../utils/classNames";
import stringToColour from "../../utils/stringToColour";
import { IContact } from './../../models/Contact';

export default function ContactAvatar({ contact, classes = "w-6 h-6", textClasses = "text-sm" }: { contact: IContact, classes?: string, textClasses?: string }) {

  return (
    <div className={`${classes} aspect-square`}>
      <span
        style={{ background: stringToColour(contact.id) }}
        className="w-full h-full inline-flex items-center justify-center rounded-full"
      >
        <span
          className={classNames(
            "text-lg leading-none text-white",
            textClasses ? textClasses : ""
          )}
        >
          {`${contact.fullname}`
            .split(" ")
            .filter((w) => RegExp(/^\p{L}/, "u").test(w))
            .map((w, i) => (i < 2 ? w.substring(0, 1).toUpperCase() : ""))}
        </span>
      </span>
    </div>
  );
}